module.exports = __webpack_public_path__ + "img/approve_bg.97ce62ff.png";